import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { memo } from 'react';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NetWorkErrorContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n"])));
var ErrorBox = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 500px;\n  flex-direction: column;\n"])));
var ErrorTitle = styled.h1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: center;\n  font-weight: bold;\n  font-size: 30px;\n"])));
var ErrorDescription = styled.h4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  text-align: center;\n"])));
export var NetworkErrorPage = /*#__PURE__*/memo(function () {
  return /*#__PURE__*/_jsx(NetWorkErrorContainer, {
    children: /*#__PURE__*/_jsxs(ErrorBox, {
      children: [/*#__PURE__*/_jsx(ErrorTitle, {
        children: "Lost Connection"
      }), /*#__PURE__*/_jsx(ErrorDescription, {
        children: "Sorry we think you have connection error, refresh the page to continue"
      })]
    })
  });
});